export default __webpack_public_path__ + "static/media/arrow_right.1efa369f.svg";